<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 lg6 offset-lg3>
          <calculator />
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>

import Calculator from "./Calculator"
import HomeLayout from "./layouts/HomeLayout"

export default {
  name: 'App',
  data () {
    return {
      refresh_token_interval: null
    }
  },
  components: { Calculator, layout: HomeLayout },
  computed: {
    logged () {
      return this.$cookies.isKey('api_token')
    }
  },
  // created () {
  //   this.refreshToken({now: true})
  //   this.refresh_token_interval = setInterval(this.refreshToken({now: false}), 300000) // refresh each 5 minutes
  // },
  // beforeDestroy () {
  //   clearInterval(this.refresh_token_interval)
  // },
  methods: {
    // refreshToken ({now=false}) {
    //   let self = this
    //   let api_token = this.$cookies.get('api_token')

    //   let successCallback = (response) => {
    //     if (response.body.data && response.body.data == 'ok') {

    //       let expire_at = new Date((new Date).getTime() + 60*60000);

    //       self.$cookies.set('api_token', self.$cookies.get('api_token'), expire_at)
    //       self.$cookies.set('user_name', self.$cookies.get('user_name'), expire_at)
    //       self.$cookies.set('user_email', self.$cookies.get('user_email'), expire_at)
    //       self.$cookies.set('business_id', self.$cookies.get('business_id'), expire_at)
    //     }
    //   }

    //   let errorCallback = (response) => {
    //     debugger
    //   }

    //   let doRequest = () => {
    //     if (api_token) {
    //       self.$http.get('https://api.biriweb.tk/refresh_token', { headers: { Token: api_token } }).then(successCallback, errorCallback)
    //     }
    //   }

    //   if (now) {
    //     doRequest()
    //     return true
    //   } else {
    //     return doRequest
    //   }
    // }
  },
  mounted() {
    this.$router.push('/sign_in')
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue